<template>
		
	<nav class="desktop-utility-nav" aria-label="Utility Navigation" v-if="utilityNav">
		
		<ul class="desktop-utility-nav__list">
			
			<li class="desktop-utility-nav__item desktop-utility-nav__item--social" v-if="utilityNav.socialLinks">
				<button type="button" class="desktop-utility-nav__toggle" aria-expanded="false" aria-controls="accordionDesktopSocial" id="btnDesktopSocial" js-desktop-social-toggle>
					{{ utilityNav.socialLinks.title }}
					<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 433.4 247" xml:space="preserve">
						<path d="M195.8,234.8L14.9,53.9c-11.6-11.6-11.6-30.2,0-41.7c11.5-11.5,30.2-11.5,41.7,0l160.1,160l160-160 c11.6-11.6,30.2-11.6,41.7,0c11.6,11.5,11.6,30.1,0,41.7L237.5,234.8c-5.7,5.7-13.3,8.6-20.8,8.6 C209.1,243.5,201.6,240.5,195.8,234.8z"/>
					</svg>
				</button>
				<div class="desktop-utility-nav__content" role="region" id="accordionDesktopSocial">
					<div class="desktop-social-links">
						<a target="_blank" :key="linkItem.id" v-for="linkItem in utilityNav.socialLinks.items" :href="linkItem.link.linkURL">{{ linkItem.link.linkText }}</a>
					</div>
				</div>
			</li>
			
			<li class="desktop-utility-nav__item" :key="item.id" v-for="item in utilityNav.nav">
				<a class="desktop-utility-nav__link" :href="item.linkURL">{{ item.linkText }}</a>
			</li>
			<li v-if="utilityNav.languages" class="desktop-utility-nav__item desktop-utility-nav__item--language-selector" js-desktop-language-selector>
				<select name="" id="">
					<option :value="language.languageCode" v-for="language in utilityNav.languages" :key="language.id">
						{{ language.displayName }}
					</option>
				</select>
			</li>
		</ul>
	</nav>
		
</template>

<script>
	
	export default {
		
		name: 'UtilityNav',
		
		props: ['utilityNav']
	}
	
</script>